import { render, staticRenderFns } from "./ArpBpmPedido.vue?vue&type=template&id=2997eda1&scoped=true"
import script from "./ArpBpmPedido.vue?vue&type=script&lang=js"
export * from "./ArpBpmPedido.vue?vue&type=script&lang=js"
import style0 from "./ArpBpmPedido.vue?vue&type=style&index=0&id=2997eda1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2997eda1",
  null
  
)

export default component.exports